import { Location } from '@angular/common';
import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { getReverseEnum } from '@frontend/sports/common/core/utils/extended-types';
import { TimerService, UrlService } from '@frontend/vanilla/core';

import { FeatureUrl } from '../../event-details-common/event-details-common.models';
import { FeatureTab } from '../../event-details-common/scoreboard/scoreboard-media-tracking.service';
import { UrlHelperService } from '../../navigation-core/url-helper.service';
import { TabBarItem } from '../../tab-bar/tab-bar.models';

@Injectable({ providedIn: 'root' })
export class HeaderNavigationUrlService {
    constructor(
        private urlService: UrlService,
        private urlHelper: UrlHelperService,
        private location: Location,
        private timerService: TimerService,
        private eventDetailsConfig: EventDetailsConfig,
    ) {}

    updateCurrentUrl(event: EventModel, tabBarItem: TabBarItem<FeatureTab>): void {
        if (this.eventDetailsConfig.showInOverlay) {
            this.timerService.setTimeoutOutsideAngularZone(() => {
                this.updateCurrentUrlInternal(event, tabBarItem);
            });
        } else {
            this.updateCurrentUrlInternal(event, tabBarItem);
        }
    }

    private updateCurrentUrlInternal(event: EventModel, tabBarItem: TabBarItem<FeatureTab>): void {
        const typedReverseFeatureTab = getReverseEnum(FeatureTab);
        const tab = FeatureUrl[typedReverseFeatureTab[tabBarItem.id]];

        const url = this.urlHelper.getEventUrl(event);
        const search = this.urlService.current().search;

        search.set('tab', tab);
        this.location.replaceState(url, search.toString());
    }
}
